// EmotionCacheProvider.tsx

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React, { PropsWithChildren, ReactElement } from 'react';
import { setNonce } from 'get-nonce';

type EmotionCacheProviderProps = PropsWithChildren<unknown> & {
  nonce: string;
};

export const EmotionCacheProvider = ({
  nonce,
  children,
}: EmotionCacheProviderProps): ReactElement => {
  const cache = createCache({
    key: 'csp',
    nonce,
  });
  setNonce(nonce);

  return <CacheProvider value={cache}>{children}</CacheProvider>;
};
